import { useContext, useEffect, useState, type ReactNode } from 'react';
import { initAxiosInterceptors } from '@/services/axiosConfig';
import { AuthContext } from '@/contexts/AuthContext';

interface AxiosConfigurationProps {
  children: ReactNode;
}

export const AxiosConfiguration = ({ children }: AxiosConfigurationProps) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const { authApi } = useContext(AuthContext);

  useEffect(() => {
    if (authApi && !isInitialized) {
      initAxiosInterceptors(authApi);
      setIsInitialized(true);
    }
    // eslint-disable-next-line react-hooks-js/exhaustive-deps
  }, [authApi]);

  // Interceptors are attached at module import; this only gates children until the auth handle is
  // injected, so their requests carry the per-request bearer from the first call.
  if (!isInitialized) {
    return null;
  }

  return <>{children}</>;
};
